import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11.4281 20.0278C11.1688 20.287 10.8545 20.4168 10.4853 20.4171C10.116 20.4168 9.80174 20.287 9.54247 20.0278L2.94281 13.4281C2.68354 13.1688 2.55374 12.8546 2.55343 12.4853C2.55374 12.116 2.68354 11.8018 2.94281 11.5425L9.54247 4.94282C9.80174 4.68355 10.116 4.55375 10.4853 4.55344C10.8545 4.55375 11.1688 4.68355 11.4281 4.94282L18.0278 11.5425C18.287 11.8018 18.4168 12.116 18.4171 12.4853C18.4168 12.8546 18.287 13.1688 18.0278 13.4281L11.4281 20.0278ZM10.4853 19.085L17.0849 12.4853L10.4853 5.88563L3.88562 12.4853L10.4853 19.085ZM10.4853 19.085L3.88562 12.4853L10.4853 19.085Z",
      fill: "black"
    }, null, -1),
    _createElementVNode("path", {
      d: "M14.4281 20.0278C14.1688 20.287 13.8545 20.4168 13.4853 20.4171C13.116 20.4168 12.8017 20.287 12.5425 20.0278L13.4853 19.085C14.1505 18.4197 20.0853 12.8546 20.0849 12.4853C20.0853 12.116 13.8199 6.22026 13.4853 5.88563L12.5425 4.94282C12.8017 4.68355 13.116 4.55375 13.4853 4.55344C13.8545 4.55375 14.1688 4.68355 14.4281 4.94282L21.0278 11.5425C21.287 11.8018 21.4168 12.116 21.4171 12.4853C21.4168 12.8546 21.287 13.1688 21.0278 13.4281L14.4281 20.0278Z",
      fill: "black"
    }, null, -1)
  ]))]))
}
export default { render: render }